import React, { useEffect, useState } from 'react'
import SideBar from './SideBar'
import axiosClient from '../axios';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { Dialog, Slide, TextField } from '@mui/material';


import loaderimg from '../assets/images/loader.gif'
import { dateConvert } from '../dateConverter';
import '../assets/css/userTable.css'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import CSVDownload from './CSVDownload';
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const StreakData = () => {
    let [data, setData] = useState([]);

    const [open, setOpen] = useState(false)
    const [bulkData, setBulkData] = useState([])
    const [detailsType, setDetailsType] = useState('')

    const [loading, setLoading] = useState(false)

    const [date, setDate] = useState({
        start: null,
        end: null,
    })

    const getStreakData = async () => {

        if ((date?.start && date?.end) && (date?.start > date?.end)) {
            alert("Start Date Can not be greater than End Date...")
            return
        }

        let startDate = date?.start ? dateConvert(date?.start) : null
        let endDate = date?.end ? dateConvert(date?.end) : null
        setLoading(true)

        await axiosClient.get(`/get-streak-data?s_date=${startDate}&e_date=${endDate}`)
            .then((res) => {
                setData(res?.data?.response)
                setLoading(false)
            })
            .catch((error) => console.log(error))
            .finally(() => setLoading(false))
    }

    const handleClose = () => {
        setOpen(false)
    }

    const handleUsedDetails = (val) => {
        setBulkData(val?.usedScratchcards || [])
        setDetailsType('Used')
        setCurrentPage(1)
        setOpen(true)
    }

    const handleUnusedDetails = (val) => {
        setBulkData(val?.scratchcards || [])
        setDetailsType('Unused')
        setCurrentPage(1)
        setOpen(true)
    }



      const handleDownload = (data) => {
            try {
                const dataToExport = data.map((val, key) => ({
                    "S.NO.": (key + 1),
                    "UserName": val?.name,
                    "UserID": val?.userId,
                    "Email Id": val?.emailId,
                    "Phone Number": val?.phoneNumber,
                    "Earnings": val?.earnings,
                    'Last Login At': val?.last_login_at,
                }));

                CSVDownload(dataToExport);
            } catch (error) {
                console.error('Error downloading CSV:', error);
            }
        };




    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 500;
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = bulkData.slice(indexOfFirstItem, indexOfLastItem);

    useEffect(() => {
        getStreakData()
    }, [])
    return (
        <>
            <SideBar handleSideBar={true} activeTab={"StreakData"} />
            <div className="screen">
                <div className="streak-header">
                    <h1>Streak Data</h1>
                    <div className="strekDate-sec">
                        <div className='pending_earning_box'>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label="Start Date"
                                    value={date?.start}
                                    onChange={(value) => { setDate({ ...date, start: value }) }}
                                    renderInput={(params) => <TextField {...params} />}
                                // maxDate={date?.end}
                                />
                            </LocalizationProvider>
                        </div>
                        <div className='pending_earning_box'>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label="End Date"
                                    value={date?.end}
                                    onChange={(value) => setDate({ ...date, end: value })}
                                    renderInput={(params) => <TextField {...params} />}
                                // maxDate={date?.end}
                                />
                            </LocalizationProvider>
                        </div>
                        {date?.start && date?.end && <button className='streak-btn' onClick={getStreakData}>Search</button>}
                    </div>
                </div>

                {
                    // data?.length > 0 ?
                    <div className="profileInfoBox table">
                        {loading ?
                            <div className='loaderImage'>
                                <img src={loaderimg} alt='loader' />
                            </div>
                            :
                            <>
                                <div style={{ width: "100%" }} className="container app-body">
                                    {
                                        data?.length > 0 ? <div className="tabel-scrol">
                                            <table id="users" style={{ width: "100%" }}  >
                                                <thead>
                                                    <tr>
                                                        <th style={{ width: '10%' }}>Day</th>
                                                        <th style={{ width: '20%' }}>Granted</th>
                                                        <th style={{ width: '20%' }}>Claimed</th>
                                                        <th style={{ width: '50%' }}>Get Details</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {data?.map((val, key) => {
                                                        return (
                                                            <tr key={key + 1}>
                                                                {/* <td>{(key + 1)}</td> */}
                                                                <td>{val.day}</td>
                                                                <td>{val?.count}</td>
                                                                <td>{val?.usedCount}</td>
                                                                <td>
                                                                    <button onClick={() => handleUsedDetails(val)} style={{ background: "none", border: "none", color: "blue", fontWeight: "bold", fontSize: "15px", marginRight: "10px" }} >Claimed Get Details</button>
                                                                    <button onClick={() => handleUnusedDetails(val)} style={{ background: "none", border: "none", color: "blue", fontWeight: "bold", fontSize: "15px" }} >Granted Get Details</button>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                            :
                                            <div style={{ textAlign: "center", fontSize: "20px", height: "100px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                No Data Found
                                            </div>
                                    }
                                </div>
                            </>}
                    </div>
                    // :
                    // <h2>No Data Found</h2>
                }
            </div>

            <Dialog
                open={open}
                onClose={() => handleClose()}
                TransitionComponent={Transition}
                className="dialogs bulkDialog"
            >
                <div className='bulkBox'>
                    <h2 style={{ textAlign: 'center' }}>{detailsType} Scratch Cards</h2>
                    <button className="bulkDataCsv" onClick={() => { handleDownload(bulkData) }}>
                        DownLoadCsv
                    </button>

                    {bulkData.length > 0 ?
                        <div style={{ width: '100%' }} className="container app-body bulkTable">
                            <div className='tabel-scrol'>


                                <table id="users">
                                    <thead>
                                        <tr>
                                            <th style={{ width: '40px' }}>S.NO.</th>
                                            <th style={{ width: '75px' }}>User Name</th>
                                            <th style={{ width: '75px' }}>User Email</th>
                                            <th style={{ width: '130px' }}>Number</th>
                                            <th style={{ width: '130px' }}>userId</th>
                                            <th style={{ width: '130px' }}>last_login_at</th>
                                            <th style={{ width: '130px' }}>earnings</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentItems.map((val, index) => (
                                            <tr key={index}>
                                                <td>{indexOfFirstItem + index + 1}</td>
                                                <td className='clickable'>{val?.name}</td>
                                                <td className='clickable'>{val?.emailId}</td>
                                                <td>{val?.phoneNumber}</td>
                                                <td>{val?.userId}</td>
                                                <td>{val?.last_login_at}</td>
                                                <td>{val?.earnings}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                            </div>


                            <div className='uploadCsv-pagination'>
                                <button
                                    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                    disabled={currentPage === 1}
                                >
                                    Previous
                                </button>
                                <button
                                    onClick={() => setCurrentPage(prev => Math.min(prev + 1, Math.ceil(bulkData.length / itemsPerPage)))}
                                    disabled={currentPage === Math.ceil(bulkData.length / itemsPerPage)}
                                >
                                    Next
                                </button>
                            </div>

                        </div>
                        : <p>No Data to load</p>}




                </div>
            </Dialog>



        </>
    )
}

export default StreakData
